import { useTranslation } from 'react-i18next';

const valueCards = [
  { key: 'spreadsheet', icon: 'ri-table-line', color: 'bg-brand-50 text-brand-600' },
  { key: 'guides', icon: 'ri-book-open-line', color: 'bg-blue-50 text-blue-600' },
  { key: 'review', icon: 'ri-star-line', color: 'bg-amber-50 text-amber-600' },
  { key: 'safety', icon: 'ri-shield-check-line', color: 'bg-emerald-50 text-emerald-600' },
];

export default function ValueProposition() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-20 bg-warm-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-warm-900 mb-3">
            {t('valueProposition.h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {valueCards.map((card) => (
            <div
              key={card.key}
              className="bg-white rounded-xl border border-warm-200 p-5 md:p-6 hover:border-brand-200 transition-all duration-300 hover:shadow-sm"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${card.color} flex items-center justify-center mb-4`}>
                <i className={`${card.icon} text-lg md:text-xl`} />
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-warm-900 mb-2">
                {t(`valueProposition.${card.key}`)}
              </h3>
              <p className="text-sm text-warm-500 leading-relaxed">
                {t(`valueProposition.${card.key}Desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}